module.exports = __webpack_public_path__ + "static/media/anthonytruong.dcf9ab8e.jpg";